module.exports = __webpack_public_path__ + "media/bubble-notification.6c84a9f1.mp3";